import { render, staticRenderFns } from "./branch-interview.vue?vue&type=template&id=365b7e81&"
import script from "./branch-interview.vue?vue&type=script&lang=js&"
export * from "./branch-interview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports